export default __webpack_public_path__ + "static/item_19-668e3cf38601b23ddec0373b20e24f1d.jpg";